import { Api } from '@/services/Api'

export default {
  getMfmData(param) {
    return Api().post('/api/v1.0/get-all-mfm-data', param)
  },
  getMfmList(param) {
    return Api().post('/api/v1.0/list-mfm', param)
  },
  getPlantConfig(plantId) {
    return Api().get(`/api/v2/plant/${plantId}`)
  },
  getLoadData(plantId, date, mode) {
    return Api().get(`/api/v2/load/live-data/${plantId}/${date}/${mode}`)
  },
  getInverterConfig(payload) {
    return Api().post('/api/v2/inverter/config', payload)
  },
  getTotalInvGeneration(plantId, date) {
    return Api().get(`/api/v2/inverter/generation/${plantId}/${date}/${date}/day`)
  }
}
